import { Link } from "react-router-dom";
import { Command as CmdIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ProjectSwitcher } from "@/components/project-switcher";
import { ThemeToggle } from "@/components/theme-toggle";
import { GodToggle } from "@/components/god-toggle";
import { SidebarMobileToggle } from "@/components/sidebar";
import { useCommandMenu } from "@/components/command-menu";

const APP_NAME = import.meta.env.VITE_APP_NAME ?? "Job Goblin";

export function TopNav() {
  const { open } = useCommandMenu();

  return (
    <header className="sticky top-0 z-30 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-14 items-center gap-3 px-4">
        <SidebarMobileToggle />
        <Link to="/" className="flex items-center gap-2 font-semibold">
          <span aria-hidden>🧌</span>
          <span className="hidden sm:inline">{APP_NAME}</span>
        </Link>

        <span className="text-muted-foreground/40">/</span>

        <ProjectSwitcher />

        <div className="ml-auto flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={open}
            className="gap-2 text-muted-foreground"
            aria-label="Open command menu"
          >
            <CmdIcon className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">Search…</span>
            <kbd className="ml-2 hidden rounded border bg-muted px-1.5 py-0.5 text-[10px] font-mono sm:inline">
              ⌘K
            </kbd>
          </Button>
          <GodToggle />
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}
